import { useParams, Navigate } from "react-router-dom";
import Logo from "../assets/logo.svg";
import Navbar from "../components/shared/Navbar";
import Footer from "../components/shared/Footer";
import { getCertificateById } from "../data/certificates";

const Certificate = () => {
  const { certificateId } = useParams();
  const certificate = getCertificateById(certificateId);

  // If certificate not found, redirect to 404
  if (!certificate) {
    return <Navigate to="/404" replace />;
  }

  return (
    <div className="bg-[#000000]">
      <Navbar />
      <div className="flex gap-4 flex-col-reverse md:flex-row justify-center pt-32 md:pt-60 pb-32 md:pb-60 container mx-4 md:mx-auto">
        <div className="flex flex-col gap-2 xl:max-w-[40%] max-w-[90%]">
          <img src={certificate.certificateUrl} alt="Certificate" className="" />
        </div>
        <div className="flex flex-col gap-2 text-white">
          <p className="text-2xl text-[#007bff]">Certificate recipient</p>
          <p className="text-2xl md:text-4xl font-bold">{certificate.name}</p>
          <p className="pt-0">{certificate.college}</p>
          <p className="text-xl font-bold">Issued By</p>
          <img src={Logo} alt="Logo" className="w-24" />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Certificate;
